const uniqueId = (string : string) => `${string}${Math.random().toString(16).slice(2)}`;

export default uniqueId;
